var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfluencer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.2,254.1s21,3.59,25.64,4.13c11.77,1.38,15.36,5.41,15.36,5.41l2.2,18.73s16.76,53,17.55,67.65,28.48,77.53,28.48,77.53H236.17S219,397.88,211.34,384.83s-7.77-25.51-10.26-31.94S179.18,314,179.18,314l-.42-.17c.51,33.25-6.5,51.71-8.66,60.69-2.37,9.89,0,53,0,53H157.32s-7.79-53.8-6.54-62.5-4.9-51-4.9-51C141.47,301.07,141.62,264,159.2,254.1Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209,197.47c5.1,5.68,10.87,17.8,7,26.65s-12.28,18.68-12.28,18.68l-2.55,13.48c-15.24.19-37.68-7-37.68-7l5.43-13.39s-18.41-32.52-4.41-48.72c0,0,2.74.89,3.66,1.15C204.59,198.59,202.74,190.52,209,197.47Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.46,187.16s9.8,8.63,3.66,18.6c-10,16.21-11.07,0-11.07,0l-16.62,9.16-4.93-15.33S154.86,183.93,164.46,187.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.93,167.09s-27.88,72,11.3,144.5S199.11,422.39,263.7,455.14s131.66,16.8,163.53-36.84-11.84-91.93-11.9-168.42,11.45-96.74-30-161.36-143.06-78.93-219.9-31S67.93,167.09,67.93,167.09Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,97.47C126.2,81.39,144.38,69,166.06,69.21c37,.46,57,33.21,78.22,58.47,11,13.1,23.49,25.74,39.83,31.9,24.52,9.23,51.81,3.84,75.7-4.73,10.69-3.84,23.37-9.24,35.42-6.48,36.63,8.38,32.81,53.08,26.76,81.39C413.82,268,400.54,308.66,373.63,338c-64.43,70.29-180.38,27.2-238.49-28.89-4.28-4.13-8.37-8.43-12.22-13a180.13,180.13,0,0,1-25.16-38.44c-18.74-39-21.32-86.29-5.08-126.54A128,128,0,0,1,112.75,97.47Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.75,97.47C126.2,81.39,144.38,69,166.06,69.21c37,.46,57,33.21,78.22,58.47,11,13.1,23.49,25.74,39.83,31.9,24.52,9.23,51.81,3.84,75.7-4.73,10.69-3.84,23.37-9.24,35.42-6.48,36.63,8.38,32.81,53.08,26.76,81.39C413.82,268,400.54,308.66,373.63,338c-64.43,70.29-180.38,27.2-238.49-28.89-4.28-4.13-8.37-8.43-12.22-13a180.13,180.13,0,0,1-25.16-38.44c-18.74-39-21.32-86.29-5.08-126.54A128,128,0,0,1,112.75,97.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-26"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50.31,
    y1: 442.26,
    x2: 441.77,
    y2: 442.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elements--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.53,97c.4,3.36-1.93,7.09-5.29,7.48s-6.49-2.69-6.88-6.06,2.17-5,5.53-5.43S113.14,93.67,113.53,97Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.61,95.27c.39,3.36-1.93,7.09-5.3,7.49s-6.48-2.7-6.88-6.06,2.18-5,5.54-5.44S128.22,91.91,128.61,95.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.53,97a1.93,1.93,0,0,1,2.9-.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.22,97.33,98,97.71S90.77,91,89.51,91.1s-.91,2.4-.91,2.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,94.61l2-.24s-9.34-7-10.79-6.82a1.24,1.24,0,0,0-1.09,1.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.56,247.66s2.71,4.83-.14,7.85c0,0,5.93,4.44,6.73,8,0,0-12.78,5.69-18.19,10.24l-20-36.09s2.27-2.8,6.59-.21S312,254.78,324.56,247.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,241.73s-.23,6.07-4.76,7.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.89,265.9a2.67,2.67,0,1,1,.32-3.76A2.68,2.68,0,0,1,316.89,265.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.08,
    y1: 249.37,
    x2: 320.08,
    y2: 253.57,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 316.68,
    y1: 249.53,
    x2: 316.7,
    y2: 254.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.99,
    y1: 248.96,
    x2: 313.54,
    y2: 253.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.08,
    y1: 247.63,
    x2: 310.63,
    y2: 251.06,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.6,
    y1: 245.95,
    x2: 307.19,
    y2: 248.83,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "292.92 237.7 290.99 239.28 310.8 274.28 312.96 273.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.56,248.75s13-8.36,25.1-8.32c0,0,.85,10.5-1,16.06l-15.52,5.15A23.33,23.33,0,0,1,386.56,248.75Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "395.15 261.64 396.43 265.49 412.46 260.17 410.67 256.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43,265.49s-1,22.08-9.76,33.84c0,0,1.77,7.07,7.43,3.35s5.5,1.56,10.58,1,5.45-8.1,9.06-5.88,6.21,2.27,8.8-2.92,5.44-.05,8.8-2.91,2.4-4.9,5.64-5.52,5.33-5.57,5.33-5.57-28.69-14.36-29.84-20.71",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "390.19 246.69 386.17 239.23 387.28 237.9 392.39 245.58",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "404.22 241.33 402.94 231.85 404.87 232.07 405.96 240.97",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.85,
    y: 83.62,
    width: 11.12,
    height: 15.78,
    rx: 1.63,
    transform: "translate(155.85 -114.65) rotate(55.27)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "191.52 83.59 208.63 73.21 212.21 78.39 196.26 90.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "178.55 92.58 161.56 106.45 164.76 111.07 183.29 99.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "189.49 87.72 187.41 91.51 190.33 92.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.77 319.66 339.25 332.84 333.07 366.41 307.26 363.86 305.4 355.69 300.07 362.02 276.41 350.87 287.77 319.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.61,
    y1: 323.57,
    x2: 336.46,
    y2: 335.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,341.65s-1.19,7.49,4.51,7.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.48,329.25s-3.91,5.44-7.66,4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.4,
    y1: 351.78,
    x2: 312.04,
    y2: 331.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.44,332.26c-.19.74-3,14.69-6.74,14.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,360.61c.48.13,21.27,2.72,21.27,2.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.5,348.41c.58.28,20,10.19,20,10.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.46,91.33c2.06-1.39,18-6,43.8,9.66s23.87,28.45,3.49,29.26S237.7,99.94,250.46,91.33Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.54,122c7-2.13-14.63-22.3-29.52-23.54s-.8,10.27-.8,10.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.07,117.77s-3.27,10.32-36.65-15.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,95.41S288,96.79,288.92,92s-7.85-.3-7.85-.3-2.78-9-6.3-7.15-3.83,4.84-.78,7.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.66,93s-.12-1.48,1.15-1.5c0,0-2.6-5.43-3.89-3.73s1.64,3.12,1.64,3.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.88,92.69s5.25-1.21,4.72,0-6.23.82-6.23.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.47,90s6.12-5.91,13.51-1.58,5.32,15.85,5.32,15.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.38,94.83s8.54,3.92,12,8.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,153.86,410,184.41l-4.88,5.53-23.67-18.33-8.52,8.9-21.28-11.7,2.08-8.71-28.4-6.76s2.62-7.49,3.59-7.55S370.27,147,370.27,147l1.84,10.85Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,153.86l1.64-3a7.8,7.8,0,0,0-5.29.55c-2.72,1.33-6,6.44-6,6.44s2.95-8.13,2.54-10.62A4.19,4.19,0,0,0,372,144l-1.75,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.11,
    y1: 157.85,
    x2: 363.03,
    y2: 173.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,168.81l-1.49,3.12,10,6.19,1.89-2.8-.73,3.35s9.76,5.52,9.88,5.25,1.74-3.41,1.74-3.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.23 170.54 373.44 174.85 372.52 175.84 368.99 171.3 370.23 170.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.8 166.12 362.17 167.46 356.32 166.7 356.26 164.84 362.8 166.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "388.72 163.46 387.83 165.33 391.91 170.78 394.02 168.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "356.49 148.1 356.22 150.28 349.54 150.6 350.27 148.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "328.55 146.06 325.75 146.17 323.11 151.71 325.5 152.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "409.72 184.72 411.79 187.48 408.22 191.42 405.54 189.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.81,329.25c15.82,2.13-7,36.57-30.79,37.16S194.47,324.48,229.81,329.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.02 366.17 188.22 372.68 188.49 382.96 195.02 374.72 195.02 366.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "188.22 372.68 189.99 374.72 192.51 374.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.99,
    y1: 374.72,
    x2: 188.49,
    y2: 382.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.5 366.86 196.73 372.98 198.92 380.54 202.15 373.18 200.5 366.86",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.73 372.98 198.43 374.15 200.27 373.55",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.43,
    y1: 374.15,
    x2: 198.92,
    y2: 380.54,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.93 364.12 184.25 366.79 181.51 374.16 188.49 370.18 190.93 364.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "184.25 366.79 184.92 368.74 186.76 369.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.92,
    y1: 368.74,
    x2: 181.51,
    y2: 374.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.45,251.71l-8.36,4,4.63,4.42s-1.91,1.22-1.31,4.34l.29,3.85-1.87.4s-1.16-2.55-2.56-2.81L138,270.8s3.86,1.91,5.43,1.11c.83-.42,2.64.49,3.28-1,1.58-3.76,3.92-12.09,3.92-12.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.67,306.35c1.06,7.36,2.57,13.67.87,16.72s-7.37,3.35-10,1.71-7.38-3.83-6-6.61a33.61,33.61,0,0,1,2.74-4.55,25.44,25.44,0,0,1,2.89-9.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,313.35s-1.22,5.72-2,7-7.73,2.5-7.73,2.5.24-2.27,5-4.73c0,0-3.42-2.77-2.82-6.29",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.08,316.32s-2.28-.66-3.52,3.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,314.11a3.56,3.56,0,0,0-2.12,1,17.58,17.58,0,0,0-1.47,3.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.08,141.76c14.88,4.07,7.35,36.43,9.33,43.32s-7.37,6.3-7.37,6.3,3.64-2.77,2-8.51c0,0-1.9,7-6.55,8.52s-14.73-3.41-21.28-1-17.18.39-13.62-7.72,1.58-14.16,1.58-24c0-1,.42-14.68,15.84-19.84S204.08,141.76,204.08,141.76Z",
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,254.1s21,3.59,25.64,4.13c11.77,1.38,15.36,5.41,15.36,5.41l2.2,18.73s16.76,53,17.55,67.65,28.48,77.53,28.48,77.53H236.17S219,397.88,211.34,384.83s-7.77-25.51-10.26-31.94S179.18,314,179.18,314l-.42-.17c.51,33.25-6.5,51.71-8.66,60.69-2.37,9.89,0,53,0,53H157.32s-7.79-53.8-6.54-62.5-4.9-51-4.9-51C141.47,301.07,141.62,264,159.2,254.1Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-26)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.43,427.55H236.17S219,397.88,211.34,384.83s-7.77-25.51-10.26-31.94S179.18,314,179.18,314l-.42-.17c0,.47,0,.93,0,1.39-.17-3.8-.42-8.1-.77-12.57l11.29-9.53s-5.22,10.23-8.44,12l11.66-2.34s-1.48,2.06-6.35,3.59c0,0,9.71,30.63,13.75,37.31s12.19,10.11,13.79,12.22.54,13,2.92,24,17.14,30.63,18.72,31c.63.14,2.81-.8,5.19-1.88C245,419.77,248.43,427.55,248.43,427.55Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.2,254.1s21,3.59,25.64,4.13c11.77,1.38,15.36,5.41,15.36,5.41l2.2,18.73s16.76,53,17.55,67.65,28.48,77.53,28.48,77.53H236.17S219,397.88,211.34,384.83s-7.77-25.51-10.26-31.94S179.18,314,179.18,314l-.42-.17c.51,33.25-6.5,51.71-8.66,60.69-2.37,9.89,0,53,0,53H157.32s-7.79-53.8-6.54-62.5-4.9-51-4.9-51C141.47,301.07,141.62,264,159.2,254.1Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.12,256.28l-.92,7.36s-5.19,2.18-15.86.74c-12.67-1.71-25.14-10.28-25.14-10.28l4.24-4.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,197.47c5.1,5.68,10.87,17.8,7,26.65s-12.28,18.68-12.28,18.68l-2.55,13.48c-15.24.19-37.68-7-37.68-7l5.43-13.39s-18.41-32.52-4.41-48.72c0,0,2.74.89,3.66,1.15C204.59,198.59,202.74,190.52,209,197.47Z",
    style: {
      fill: "#4819F2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-26)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216,224.12C212,233,203.67,242.8,203.67,242.8l-1.22,6.45-5.34,6.84s-5.27-5.4-7.25-11.6c0,0-4,3.73-9.2,9.28-9.48-2-17.22-4.5-17.22-4.5l5.43-13.39s-8.1-14.32-9.46-28.69l9.56-3s-.41,4.69-2.44,7.18c1.53-1.51,5.18-4.79,5.39-2.14.27,3.36-.82,3.79-.37,6.79s11,11.47,14.75,12.66,8.84-4.51,11.34-3.84,5.59,3.8,9.27-2.36,4.31-16.35,3.25-19.12c-.74-2,3.82,5,6.55,9.45A18.55,18.55,0,0,1,216,224.12Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209,197.47c5.1,5.68,10.87,17.8,7,26.65s-12.28,18.68-12.28,18.68l-2.55,13.48c-15.24.19-37.68-7-37.68-7l5.43-13.39s-18.41-32.52-4.41-48.72c0,0,2.74.89,3.66,1.15C204.59,198.59,202.74,190.52,209,197.47Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.81,198.3c-1,3.75-3.19,9.12-7.8,8.91-9.4-.44-30.23-18.33-30.87-18.89.5.07,9.8,1.38,11.64-1.22a6.93,6.93,0,0,0,.94-2.62,30.79,30.79,0,0,0,.36-5.56,86.94,86.94,0,0,0-.67-9.51l19.41.73a70,70,0,0,0-3.91,9.06,30.44,30.44,0,0,0-1.7,7.28,8.13,8.13,0,0,0,.62,4.31c1.06,2.05,6,3.12,9.42,3.62A3.12,3.12,0,0,1,206.81,198.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,198a62.8,62.8,0,0,0-7.48,2.35,2.55,2.55,0,0,0-1.42,2.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,202.15a5.75,5.75,0,0,0-3.57-2.88c-2.61-.73-12.9-3.67-18.89-6.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,187.16s9.8,8.63,3.66,18.6c-10,16.21-11.07,0-11.07,0l-16.62,9.16-4.93-15.33S154.86,183.93,164.46,187.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-26)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.58,210.3a10.46,10.46,0,0,1-.24,2.21c-4.47,2.47-5.23-6-5.29-6.71C159.44,204.88,162.6,204.72,162.58,210.3Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.46,187.16s9.8,8.63,3.66,18.6c-10,16.21-11.07,0-11.07,0l-16.62,9.16-4.93-15.33S154.86,183.93,164.46,187.16Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.76,313.85c0-2.8-.75-11.18-.75-11.18s9.76-7.91,12.93-11.07,1.34,4.22-3.42,6.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1,302.33s-8.91,2.75-15.86,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.83,300.17s-5.15-5.41-11-7.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,266.81a17.94,17.94,0,0,0,4.5-1,3.42,3.42,0,0,1,.43,3.66,30.28,30.28,0,0,1-4.69,1.16A24.35,24.35,0,0,0,196,266.81Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05,255.33a66.73,66.73,0,0,0,26.33,10.95,45.54,45.54,0,0,0,9.68.76q.06.33.09.63a25.09,25.09,0,0,1,.19,3.25c-8.9.62-17.22-2.53-24-4.9a73.56,73.56,0,0,1-15.16-7.39Z",
    style: {
      fill: "#757575",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.18,268.2c-.21,1.61,1.43,3.14,3.66,3.43s4.21-.77,4.41-2.37-1.43-3.14-3.66-3.43S180.39,266.6,180.18,268.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,245.18l10,15,13.45-7.16,1.59,7.42-6.6,10.12s7.45,3.86,9,5.18,23.35-5.51,23.35-5.51c4.64-16.62,23.13-34.22,23.13-34.22-28.31-17.44-48.56-40.08-55.92-39.9-6.79.17-3.39,2.46-3.39,2.46l-22.57,16.31C105.49,222.77,122.1,245.18,122.1,245.18Zm16-13.84s.39-2.77,6.19-4.36v2.21l4.69,3.2,1.78,7.25-1.78,2.64-3-3.16-2.51.52S138.06,233.91,138.06,231.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.26,234.76s17-5,18.41-19a25,25,0,0,0-8.23-21.6s6.47-1.28,8.23-1.31l.14,3.34,5,4.68,1.44,9.55s2.52,4.74,1.14,13,.23,32.29.41,33.65a8.06,8.06,0,0,0,1.34,2.95s1.41,19.58,1.41,24.92a29,29,0,0,0,1.38,9.1,92.19,92.19,0,0,0,0,11.29s-10.57,3.94-14.78,2.95c0,0-2.62-14.93-4.4-17.46,0,0,2.05-10.16-.4-15.77l-4.74,2.57S191,250.75,192.26,234.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.74,198s4.52,16.53,0,22.48",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.34,
    cy: 236.61,
    r: 1.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.23,226.32c-3.08,4.62-12.71,13.59-12.71,16.22s-3.29,1.32-3.29,1.32",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.6,246.63l2.37,8.31s1.12,9,3.26,11.73-8.11,8.31-8.11,8.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.23,239.64s2.13,11.65,8,16.64",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.29,288.56s-5.31,7.65-11.16,3.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.55,250.62l3-5s-3.76-4-4.75-4.75-10.7,6.06-11.68,5.8",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,228c-.21-5.54-12.08-7.52-12.08-7.52",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.46,208.15s6.66,12.26,3.5,17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.32,202.15c1.14.11,23.5,7,31.8,16.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52,239.64c-1-.39-13.33,10.75-20.52,9.63",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.48,240.77c1.14,2,5.41,12.26,6.64,12.29",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,260.81s16.7,4.94,21.2-2.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.46,220.45c-.19,1-6,10.88-9.49,8.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.05,205.76c.39-.8,4.9-1.39,5.53,2.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.71,303.35s-6.9-5.24-15.2-3.82A34.27,34.27,0,0,0,172.71,303.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,308.83c-.34-.14,13,.25,17.63,2C174.14,310.81,164.5,312.19,156.51,308.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,312.77s-5.77-1.89-10.66,0S164.21,315.68,167.17,312.77Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.14,320.5c.94-.46-6.55-4.15-14.11-.59C160,319.91,170.9,322.08,174.14,320.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,323.47a26.16,26.16,0,0,0-10.55-.8S165,324.75,169,323.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,329.2s-5.39-1.38-9.62,0C161.28,329.2,167.7,331.08,170.9,329.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.46,302.25a12.4,12.4,0,0,0-11.08,4.13S201.19,305.17,205.46,302.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,304.85s-3.57,2.51-11,3.51C195,308.36,203.79,310.26,206.05,304.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,309.81s-5.32.15-8,1.83C195,311.64,200.88,312.72,203,309.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,311.84s-8.2.07-11.29,3.25C196.73,315.09,203.86,317.87,208,311.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.73,315.09a6.94,6.94,0,0,0-4.34,1.68A3.19,3.19,0,0,0,209.73,315.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,320.64s-.82-.36-9.77,3.08C201.31,323.72,208.27,326.58,211.08,320.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,327.19s-4-.42-5.62,2C205.46,329.15,209.66,330,211.08,327.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,411.66s-3.6-.77-4.37,0c-1.7,1.7-.47,6.9-.47,6.9s-3.21-5.67-8.74-4.15l-5.53,1.52s6.37,9.63,6.59,13.35-1.76,8.1,1.85,13H273s3.86-6.34-1-7.56c-18.53-4.63-22.43-11-24-13.71S244.8,411.66,244.8,411.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.67,419.81c2.43,3.6,6.11,6.33,9.76,8.57.64.39,9.18,5,4.65,5.65",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,421s-2.56-.67-5.85,2.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,424a11.24,11.24,0,0,0-5.57,2.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.49,426.29s-3.71,1-5.22,2.62",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,428.91a11.7,11.7,0,0,0-4.81,2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.48,442.26s1.61-6.4,0-8.35-6.33-15.29-4.67-20.57l-2.6.75s-1.57-5.2-8-4.64-5.28,6.67-5.28,6.67-1.95.28-2.51,1.39c0,0,4.45,11.4,1.95,13.9s-6.95,4.73-4.45,10.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.47,415.5c-.5,3.37.36,6.82.38,10.2,0,2.56-2.62,5.44-.18,7.17",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.81,417.29c1.77,2.66,1.24,6.42,1.46,9.47s.22,5-2.3,7.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,421.4s-8.58-3.1-13.15.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,425s-7.32-2.85-13.15,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,428.18s-8.16-2.61-13.15,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,431.2s-7.76-3.53-13.15,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.38,273.93s-.49,15.69-4.22,22.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.17,273.93a65.23,65.23,0,0,1-1.45,12.45,2.76,2.76,0,0,1-2.71,2.18h-.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.91,179.2a30.44,30.44,0,0,0-1.7,7.28c-3.59-2-6-6.57-6-6.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.11,178.06c-10.17-9.28-7.5-30.52.48-34.9,14.88-8.16,20.83,2.15,22.28,8.14,1.23,5.08-.21,11.95.63,15,2.1,7.6-4.49,16.92-9,17.75-2.8.51-5.8-.46-9.13-2.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.83,160.76s3.93-3.8,7.86-2.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.63,156s3.5-1.1,5.19,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,161.83c.07,1-.32,1.84-.87,1.88s-1.06-.74-1.13-1.75.32-1.84.87-1.88S203.1,160.82,203.17,161.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,165.27a5.33,5.33,0,0,0,2.14,2c1.2.44-1.07,3.31-1.07,3.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.26,173.42s-4.58,1.28-8.07-.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.69,173.52s1.89,3.13,4.53,3,2.32-3,2.32-3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,175.59s-3.76-6.24-2.5-12.07c0,0,.94-.65,2.1,1.47,0,0,7.35-13.57,19-18,0,0,7.17,2.3,6.89,15.89a29.1,29.1,0,0,0,1.54-9.1c-.37-9-5.53-12.16-5.53-12.16-1.78-6.16-20.79-7.64-30.28,2-11.87,12.09-3.17,24.24-4.58,36.2",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.08,141.76c-1.78-6.16-22.44-7.73-31.93,2-11.87,12.09-3,24.73-4.58,36.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,175.59s-3.76-6.24-2.5-12.07c0,0,.94-.65,2.1,1.47,0,0,7.35-13.57,19-18,0,0,7.17,2.3,6.89,15.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.49,171.65s-1.54,3.11.32,7.6,2.92,3.82,2.92,3.82-2.9,1.77-5.41-1.95c0,0,.68,4,3.07,5,0,0-2.28,2.77-5.84,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,154.06a22.36,22.36,0,0,0-7.65,20",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,144.53s-6.56-7-17,1.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.59,148.25s5.51,2.58,6.15,13.36-1.19,15.62,1,21.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,179.91s-1.67,10.26-6.56,11.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,163.52s3.13-10.2,9.45-14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,148.25c-.39.67-6.17,7-4.33,23.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.65,166.18c-.19-1.5-4-4.53-5.32-2.91s-.76,7.39,1.77,8.87,4.41,2.9,4.41,1",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.25,172.29c2.88-.08,3.58,8.88,0,9.4-3.06.44-3-6.88-1.13-8.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,162.81s2.58-.75,4.06,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41,207.21a13.49,13.49,0,0,1,2.36-1.3Z",
    style: {
      fillOpacity: 0.7000000000000001,
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.18,168.42l7.35-8.52a1.44,1.44,0,0,1,2-.15L150.31,169a1.43,1.43,0,0,1,.49,1.26l-.75,6.77a1.44,1.44,0,0,1-1.07,1.24L142.39,180a1.42,1.42,0,0,1-1.31-.3l-10.75-9.26A1.45,1.45,0,0,1,130.18,168.42Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.27,172.42l.47.41-.7.82-.48-.41a1.81,1.81,0,0,1-2.47-.27l-.2-.17.81-.94.26.22c.46.4.79.36,1.06,0s.26-.64-.19-1-.93-.49-2.05-.28a3,3,0,0,1-2.83-.52,1.86,1.86,0,0,1-.63-2.43l-.46-.4.71-.82.46.4a1.83,1.83,0,0,1,2.49.27l.44.38-.82.94-.5-.43c-.45-.39-.78-.33-1.06,0s-.28.65.17,1,.94.5,2.05.28a2.92,2.92,0,0,1,2.82.52A1.82,1.82,0,0,1,144.27,172.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.73,262.05l-4.43,10.34a1.44,1.44,0,0,1-1.9.76l-13-5.58a1.44,1.44,0,0,1-.85-1.05l-1.33-6.69a1.45,1.45,0,0,1,.65-1.5l5.75-3.65a1.44,1.44,0,0,1,1.35-.11l13,5.58A1.46,1.46,0,0,1,260.73,262.05Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.09,262.49l-.57-.25.42-1,.57.25A1.83,1.83,0,0,1,249,261l.24.11-.49,1.14-.32-.13c-.55-.24-.86-.11-1,.28s-.05.69.5.93,1,.18,2-.36a3,3,0,0,1,2.85-.35,1.84,1.84,0,0,1,1.34,2.12l.56.24-.43,1-.56-.24a1.82,1.82,0,0,1-2.45.5l-.53-.22.49-1.15.6.26c.55.24.86.08,1-.31s.07-.71-.48-.95-1-.18-2,.36a3,3,0,0,1-2.85.36A1.83,1.83,0,0,1,246.09,262.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53,305.8l-6.18-9.41a1.45,1.45,0,0,1,.42-2l11.86-7.78a1.45,1.45,0,0,1,1.34-.13l6.31,2.59a1.46,1.46,0,0,1,.9,1.37l-.14,6.81a1.44,1.44,0,0,1-.65,1.18l-11.86,7.78A1.44,1.44,0,0,1,114.53,305.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,293.36l.52-.35.59.91-.52.34a1.81,1.81,0,0,1-.94,2.31l-.22.14-.68-1,.29-.19c.5-.33.56-.66.33-1s-.55-.42-1.05-.09-.72.75-.83,1.89a3,3,0,0,1-1.28,2.57,1.85,1.85,0,0,1-2.51-.06l-.51.33-.59-.9.51-.33a1.84,1.84,0,0,1,.94-2.33l.48-.32.69,1-.55.36c-.5.33-.54.67-.31,1s.56.45,1.06.12.73-.76.82-1.89a2.93,2.93,0,0,1,1.28-2.57A1.83,1.83,0,0,1,122.25,293.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,289.48s4-2.86,6.93-1.38,6.42,2,8-.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.22,259.13s-6.93,2-10-6.07-9-10.15-12-8.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.62,177.92s1.17,2.58,5.52,2,10.38,2.56,10,7.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Post--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.73,126.48,87.67,352.12,289.61,337,272.67,111.32Zm8,12.2,187.79-14.1,14.1,187.78L92.86,326.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.94,321.06c1.19-2.4,3.94-1.76,5.47-.12,1.22-1.89,3.82-3,5.41-.86,2.7,3.62-1.84,7.6-4,9.19l-.62.45-.69-.34C273.09,328.2,267.92,325.09,269.94,321.06Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.1 343.04 98.85 340.25 103.96 342.29 103.22 332.44 93.36 333.18 94.1 343.04",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.76,320.28l-7.53.57a1.37,1.37,0,0,0-1.26,1.46l.47,6.23a1.37,1.37,0,0,0,1.46,1.26l2.89-.22,1,1.79.74-1.92,2.89-.22a1.35,1.35,0,0,0,1.25-1.46l-.46-6.23A1.37,1.37,0,0,0,258.76,320.28Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.23,157.65h-64a8.36,8.36,0,0,0-8.36,8.36v38.12a8.36,8.36,0,0,0,8.36,8.36h8l-7.37,14,17-14h46.34a8.35,8.35,0,0,0,8.35-8.36V166A8.36,8.36,0,0,0,311.23,157.65Z",
    style: {
      fill: "#4819F2",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.57,173.06H250.9a1.29,1.29,0,0,1-1.29-1.29h0a1.29,1.29,0,0,1,1.29-1.29h56.67a1.28,1.28,0,0,1,1.28,1.29h0A1.28,1.28,0,0,1,307.57,173.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,181.73H250.9a1.29,1.29,0,0,1-1.29-1.29h0a1.29,1.29,0,0,1,1.29-1.29h56.67a1.28,1.28,0,0,1,1.28,1.29h0A1.28,1.28,0,0,1,307.57,181.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,190.39H250.9a1.29,1.29,0,0,1-1.29-1.29h0a1.28,1.28,0,0,1,1.29-1.28h56.67a1.28,1.28,0,0,1,1.28,1.28h0A1.28,1.28,0,0,1,307.57,190.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.57,199.06H250.9a1.29,1.29,0,0,1-1.29-1.29h0a1.29,1.29,0,0,1,1.29-1.29h29.67a1.28,1.28,0,0,1,1.28,1.29h0A1.28,1.28,0,0,1,280.57,199.06Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 338.91,
    y: 218.46,
    width: 32.39,
    height: 19.46,
    rx: 2.02,
    transform: "translate(583.29 -126.92) rotate(90)",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,217.93a.86.86,0,1,1,.86-.86A.85.85,0,0,1,360.92,217.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,217.93a.86.86,0,1,1,.86-.86A.86.86,0,0,1,358.42,217.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.92,220.3a.86.86,0,1,1,.86-.85A.85.85,0,0,1,360.92,220.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,220.3a.86.86,0,1,1,.86-.85A.86.86,0,0,1,358.42,220.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 347.15,
    y1: 214.76,
    x2: 347.15,
    y2: 241.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.45,233.74V224.6a1,1,0,0,0-1-1h-1.66v2.46H348.44v-1.71a.75.75,0,0,0-.74-.75h-3.92a1,1,0,0,0-1,1v9.13a1,1,0,0,0,1,1h22.65A1,1,0,0,0,367.45,233.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.5 442.25 383.22 442.25 343.22 254.32 338.5 254.32 378.5 442.25",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.22 442.25 298.5 442.25 338.5 254.32 343.22 254.32 303.22 442.25",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.5,
    y: 254.32,
    width: 4.72,
    height: 187.94,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.25,224.6h3.22a1.53,1.53,0,0,1,1.53,1.53v25.2a0,0,0,0,1,0,0h-6.28a0,0,0,0,1,0,0v-25.2A1.53,1.53,0,0,1,339.25,224.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.65,
    y: 249.75,
    width: 14.43,
    height: 6.53,
    rx: 1.53,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.5,229.17h-3.94v-4.53a1,1,0,0,0-1.05-1h0a1.05,1.05,0,0,0-1.06,1v4.49a1.05,1.05,0,0,0,1.06,1.05h5Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencer);
export default __webpack_public_path__ + "static/media/influencer.3d42e0a8a41753af1fae2794cc6ccb02.svg";
export { ForwardRef as ReactComponent };